
import {Document} from "./document";
import {DocumentCategory} from "./documentCategory";

/**
 * Created by Lauta on 09/10/2017.
 */

const visible = "show";
const hidden = "hide";
const displayLength = 13;

export class DocumentCategoryView extends DocumentCategory{
    visibility: string = "hide";
    subCategories: DocumentCategoryView[] = [];
    documents: Document[] = [];
    loadedSubCategories = false;
    loadedDocuments = false;


    constructor(value: Object = {}) {
        super(value);
    }

    public isEmpty() : boolean {
        return ( this.loadedSubCategories && this.loadedDocuments ) && ( this.documents.length == 0 && this.subCategories.length == 0 );
    }

    public changeVisibility() {
        this.visibility = visible == this.visibility ? hidden : visible;
    }

    public isVisible() : boolean {
        return this.visibility == visible;
    }

    public isSubCategoriesLoaded() : boolean {
        return this.loadedSubCategories;
    }

    public isDocumentsLoaded() : boolean {
        return this.loadedDocuments;
    }

    public loadSubCategories( c : DocumentCategoryView[] ) : void{
        this.subCategories = c;
        this.loadedSubCategories = true;
    }

    public loadDocuments( d : Document[] ) : void{
        this.documents = d;
        this.loadedDocuments = true;
    }

    public getDisplayName() : string{
        if ( this.name.length > displayLength ){
            return this.name.slice(0,displayLength-4)+"...";
        } else {
            return this.name;
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/documentCategoryView.ts